import { isServer, keepPreviousData, QueryClient } from "@tanstack/react-query";

/** Paginated lists should refetch when the page/filter key changes, not on tab focus. */
export const paginatedListQueryOptions = {
  staleTime: 0,
  gcTime: 5 * 60 * 1000,
  refetchOnMount: true,
  refetchOnWindowFocus: false,
  placeholderData: keepPreviousData,
} as const;

/** Dashboard should always load fresh data when the page is opened. */
export const dashboardQueryOptions = {
  staleTime: 0,
  refetchOnMount: "always" as const,
  refetchOnWindowFocus: false,
};

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) {
      browserQueryClient = makeQueryClient();
    }
    return browserQueryClient;
  }
}
